import {Button, Col, Divider, Layout, Row} from "antd";
import {ArrowLeftOutlined, ArrowRightOutlined} from "@ant-design/icons";
import {useState} from "react";
import './layout.css'
import {isMobile} from "react-device-detect";
import {Footer} from "antd/es/layout/layout";

const { Sider } = Layout;



export default function BaseLayout({children})
{
    const [open, setOpen] = useState(false);

    return (
        <div>
            <Layout style={{
                backgroundColor: '#e6eef2',
                marginLeft: 32,
                marginRight: 32,
                marginBottom: 12
            }}>
                {children}
            </Layout>
        </div>
    )
}
